<template>
    <CrossTabComponent
      :show-toast-message="passedPropData.showToastMessage"
      :translations="passedPropData.translations"
      :routes-map="passedPropData.routesMap"
      :min-height="passedPropData.minHeight"
      :accent-color="passedPropData.accentColor"
      @notification-added="handleNotification"
      :i18n="i18n"
      :prevent-scrolling-over-modal="passedPropData.preventScrollingOverModal"
    />
</template>

<script setup>
    import { onBeforeMount, ref } from 'vue'
    import { i18n } from "@/modules/crossTable/crossTableVue"
    import { CrossTabComponent } from "crosstab/dist-lib/crosstab.es"
    import 'crosstab/dist-lib/style.css'
    import M from "materialize-css"

    const passedPropData = ref({})

    onBeforeMount(() => {
      passedPropData.value = window.crossTabSettings || {}
    })

    const handleNotification = (notification) => {
        M.toast({
            html: notification.message || notification.title,
            classes: 'background-' + (notification.type === 'success' ? 'true' : 'false')
        })
    }
</script>
